/** Lo que hace falta de un cliente para nombrarlo. Vale tanto el modelo `Cliente` como el objeto
 * plano que llega en las pantallas que no pasan por él (Salidas) */
export interface DatosNombreCliente {
    nombre?: string | null;
    apellido1?: string | null;
    apellido2?: string | null;
    denominacionSocial?: string | null;
    empresa?: boolean | null;
    nombreCompleto?: string | null;
}

/**
 * Cómo se nombra al cliente en las tablas y en los buscadores: por su nombre y apellidos, no por su
 * razón social. En las empresas el «nombre» suele llevar el nombre comercial. Si no hay nombre, la
 * razón social, para no dejar la celda vacía.
 */
export function nombreYApellidosCliente(cliente: DatosNombreCliente | null | undefined): string {
    if (!cliente) {
        return '';
    }
    return nombreDePersona(cliente) || razonSocialCliente(cliente);
}

/**
 * Cómo se nombra al cliente en las facturas: la razón social si es empresa, y si no, su nombre. Es lo
 * mismo que `nombreCompleto` de la API, que manda cuando llega.
 */
export function razonSocialCliente(cliente: DatosNombreCliente | null | undefined): string {
    if (!cliente) {
        return '';
    }
    if (cliente.nombreCompleto) {
        return cliente.nombreCompleto;
    }
    if (cliente.empresa && cliente.denominacionSocial) {
        return cliente.denominacionSocial;
    }
    return nombreDePersona(cliente);
}

/** Nombre y apellidos. Muchos clientes importados llevan ya los apellidos dentro del nombre: un apellido
 * que ya está en el nombre no se repite */
function nombreDePersona(cliente: DatosNombreCliente): string {
    const nombre = (cliente.nombre || '').trim();
    const apellidos = [cliente.apellido1, cliente.apellido2]
        .map(parte => (parte || '').trim())
        .filter(parte => parte && !contienePalabras(nombre, parte));
    return [nombre, ...apellidos].filter(parte => parte).join(' ');
}

/** Si `parte` aparece en `texto` como palabras enteras, sin distinguir mayúsculas ni tildes */
function contienePalabras(texto: string, parte: string): boolean {
    const normalizar = (t: string) => ' ' + t.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .toLowerCase().split(/\s+/).filter(p => p).join(' ') + ' ';
    return normalizar(texto).includes(normalizar(parte));
}
